<h2>
  {{'team_ranking' | transloco}}: &nbsp;
  <span>
    {{ (filter_service.categoriesCombo.comboData | async)?.name }}
    {{ (filter_service.yearCombo.comboData | async)?.Year }}
  </span>
</h2>

<app-wa-table
  [showNoResultsMessageCondition]="ShowNoResultsBox"
  [showNoResultsMessage]="customLoadMsg"
  [isSortableFunc]="sortClass"
  [showCondition]="true"
  [headers]="headers"
  [isDataLoading]="loading && (filter_service.categoriesCombo.comboData|async) != undefined"
  [areMoreData]="areMoreData() && (filter_service.categoriesCombo.comboData|async) "
  (loadMore)="loadMore()"
  [data]="data"
  (headerClick)="changeSort($event)"
>
  <ng-template [extraClass]="['td-10']"  app-column let-ranking>
    <div style="display: flex; justify-content: center; flex-direction: column;">
    <div class="border-ranking-box" >{{ ranking.Rnk }}</div>


    <div style="height: 10px;" *ngIf="ranking.Rnk === ranking.RnkOld;else variation" class="icon--equal"></div>
    <ng-template #variation>
      <div *ngIf="ranking.RnkOld && (ranking.Rnk < ranking.RnkOld)" class="icon--up">
        {{ {rank:ranking.Rnk, rankOld: ranking.RnkOld} | parseRank}}
        </div>
      <div *ngIf="ranking.RnkOld && (ranking.Rnk > ranking.RnkOld)" class="icon--down">
        {{ {rank:ranking.Rnk, rankOld: ranking.RnkOld} | parseRank}}
      </div>
      <ng-container *ngIf="ranking.Rnk && ranking.RnkOld == null">
        <div style="text-align: center; font-size: 12px;" class="list-row-item__ranking__arrow new new__margin">
          {{'NEW' | transloco}}
        </div>
      </ng-container>

    </ng-template>

  </div>
  </ng-template>
  <ng-template app-column let-ranking>
    <img class="logo-team" [lazyLoad]="ranking.Logo" />
  </ng-template>
  <ng-template app-column let-ranking>
    <div class="uppertext-no-viewport">{{ ranking.Name }}</div>
  </ng-template>
  <ng-template app-column let-ranking>
    <div *ngFor="let athlete of ranking.Members">
      <lib-athlete-name
        [wnameord]="athlete.WNameOrd"
        [fname]="athlete.FName"
        [gname]="athlete.GName"
        [id]="athlete.Id"
      ></lib-athlete-name>
    </div>
  </ng-template>
  <ng-template app-column let-ranking
    ><div class="uppertext-black-no-viewport">{{ ranking.Score }}</div>
  </ng-template>
  <ng-template app-column let-ranking>
    <div
      class="list-row-item__action"
      *ngIf="{ data: data, showDetails: false } as detail"
      (click)="selectIndex(ranking.index)"
    >
      <span
        class="plus-minus {{
          isIndexSelected(ranking.index) === false
            ? 'plus-minus--more'
            : 'plus-minus--less'
        }}"
      >
      </span>
    </div>
  </ng-template>
  <ng-template [extraClass]="['td-33']" app-column-responsive let-ranking>
    <div style="display: flex; justify-content: center; flex-direction: column;">
      <div class="border-ranking-box" >{{ ranking.Rnk }}</div>


      <div style="height: 10px;" *ngIf="ranking.Rnk === ranking.RnkOld;else variation" class="icon--equal"></div>
      <ng-template #variation>
        <div *ngIf="ranking.RnkOld && (ranking.Rnk < ranking.RnkOld)" class="icon--up">
          {{ {rank:ranking.Rnk, rankOld: ranking.RnkOld} | parseRank}}
          </div>
        <div *ngIf="ranking.RnkOld && (ranking.Rnk > ranking.RnkOld)" class="icon--down">
          {{ {rank:ranking.Rnk, rankOld: ranking.RnkOld} | parseRank}}
        </div>
        <ng-container *ngIf="ranking.Rnk && ranking.RnkOld == null">
          <div style="text-align: center; font-size: 12px;" class="list-row-item__ranking__arrow new new__margin">
            {{'NEW' | transloco}}
          </div>
        </ng-container>

      </ng-template>

    </div>  </ng-template>
  <ng-template
    app-column-responsive
    let-ranking
    [extraClass]="['wa-table__cell--fit']"
  >
    <div class="team-wrapper">
      <img style="width: 75px;" class="logo-team" [lazyLoad]="ranking.Logo" />
      <p class="name-team" style="word-break: keep-all;">{{ ranking.Name }}</p>
    </div>
    <div class="border-content" style="display: flex; flex-direction: column;">
      <lib-athlete-name
        *ngFor="let athlete of ranking.Members"
        [wnameord]="athlete.WNameOrd"
        [fname]="athlete.FName"
        [gname]="athlete.GName"
        [id]="athlete.Id"
      ></lib-athlete-name>
    </div>
    <div>
      <span class="uppertext-no-viewport">{{'Points' | transloco}}: </span>{{ ranking.Score }}
    </div>
  </ng-template>
  <ng-template
    [extraClass]="['wa-table__cell--fit-right']"
    app-column-responsive
    let-ranking
  >
    <div
      class="list-row-item__action"
      *ngIf="{ data: data, showDetails: false } as detail"
      (click)="selectIndex(ranking.index)"
    >
      <span
        class="plus-minus {{
          isIndexSelected(ranking.index) === false
            ? 'plus-minus--more'
            : 'plus-minus--less'
        }}"
      >
      </span>
    </div>
  </ng-template>
  <ng-template app-row let-ranking>
    <td colspan="100%" class="wa-table__cell wa-table__cell--fit">
      <div
        *ngIf="isIndexSelected(ranking.index) === true"
        class="wa-table-details"
        [@slideInOut]="animationState"
      >
        <app-wa-table
          class="inner-table-open"
          [isSortableFunc]="sortClass"
          [showCondition]="true"
          [headers]="detailHeaders"
          [isDataLoading]="false"
          [areMoreData]="false"
          (loadMore)="loadMore()"
          [data]="ranking.Details"
          (headerClick)="changeSort($event)"
        >
          <ng-template app-row let-detail>
            <td></td>
            <td class="td-25"></td>
            <td class="td-25" *ngFor="let athlete of ranking.Members">
              <ng-container *ngIf="detail.index === 0">
                <div class="athlete-detail">
                  <lib-athlete-photo
                    [isTeam]="false"
                    [id]="athlete.Id"
                  ></lib-athlete-photo>
                  <lib-athlete-name
                    [fname]="athlete.FName"
                    [gname]="athlete.GName"
                    [wnameord]="athlete.WNameOrd"
                    [id]="athlete.Id"
                  ></lib-athlete-name>
                </div>
              </ng-container>
            </td>
            <td></td>
          </ng-template>
          <ng-template [extraClass]="['border-bottom']" app-row let-detail>
            <td class="visibility--hide-mobile">
              <div
                [isImage]="true"
                style="border-radius: 50%;"
                [competitionId]="detail.ID"
                [size]="70"
                appCompetitionLink
              ></div>
            </td>
            <td style="text-align: left;" class="border-bottom td-25">
              <a

                class="uppertext-black-no-viewport"
                appCompetitionLink
                [competitionId]="detail.ID"
                >{{ detail.NameShort ? detail.NameShort : detail.Name }}</a
              >
              <div

              class="uppertext-no-viewport">
                {{ detail.Date | date: "yyyy" }}
              </div>
            </td>
            <td class="border-bottom td-25" *ngFor="let athlete of ranking.Members">
              <div>
                {{
                  detail.ScoreDetailed[athlete.Id]
                    ? detail.ScoreDetailed[athlete.Id]
                    : "-"
                }}
              </div>
              <div>
                <app-position-medals
                  *ngIf="detail.RankDetailed[athlete.Id]; else none"
                  [Rnk]="detail.RankDetailed[athlete.Id]"
                >
                </app-position-medals>
                <ng-template #none><div></div></ng-template>
              </div>
            </td>
            <td class="border-bottom td-25">
              <div
                [ngClass]="{
                  'uppertext-black-no-viewport': detail.inTotal === true
                }"
              >
                {{ detail.Score }}
              </div>
            </td>
          </ng-template>
        </app-wa-table>
        <!--   <tr></tr>
        <tr *ngFor="let detail of ranking.Details">
          <td>
            <img [competitionId]="detail.ID" [size]="75" appCompetitionLink/>
          </td>
          <td>
            <a appCompetitionLink [competitionId]="detail.ID">
            {{detail.NameShort ? detail.NameShort : detailName}}
          </a>
          <div>{{detail.Date | date :'yyyy'}}</div>
          </td>

        </tr>
      </table>-->
      </div>
    </td>
  </ng-template>
</app-wa-table>
